import FieldGrid from "../detail/FieldGrid";
import SideCard from "../detail/SideCard";
import { DetailOf } from "../detail/types";
import { severityLabel, shortDate, statusLabel } from "../governanceStatus";

const retestText = (retest: DetailOf<"ISSUE">["retest"]): string | null => {
  if (!retest?.result) return null;
  const parts = [statusLabel(retest.result)];
  if (retest.by) parts.push(`by ${retest.by}`);
  if (retest.at) parts.push(shortDate(retest.at));
  return parts.join(" · ");
};

/** Issue fields, read-only. */
const IssuePanel = ({ item }: { item: DetailOf<"ISSUE"> }) => (
  <SideCard title="Issue details">
    <FieldGrid
      fields={[
        { label: "Environment", value: item.environment },
        { label: "Severity", value: severityLabel(item.severity) },
        // reportedAt is a timestamp (set when the issue is filed).
        { label: "Date reported", value: shortDate(item.reportedAt || item.createdAt) },
        { label: "Retest result", value: retestText(item.retest) },
        { label: "Steps to reproduce", value: item.stepsToReproduce, full: true },
        { label: "Expected result", value: item.expectedResult, full: true },
        { label: "Actual result", value: item.actualResult, full: true },
        { label: "Business impact", value: item.businessImpact, full: true },
        { label: "Resolution", value: item.resolution, full: true },
      ]}
    />
  </SideCard>
);

export default IssuePanel;
